import { useState, useEffect, useRef } from "react";
import { GetFullListOfUsers, updateUserRole } from "../../../api";
import { toast } from "sonner";
import { User } from "./types";

export function useUsersController() {
  const [users, setUsers] = useState<User[]>([]);
  const [filteredUsers, setFilteredUsers] = useState<User[]>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const initialised = useRef<boolean>(false);
  const [subscribed, setSubscribed] = useState<User[]>([]);
  const [notSubscribed, setNotSubscribed] = useState<User[]>([]);
  const [admins, setAdmins] = useState<User[]>([]);
  const [loading, setLoading] = useState(true);

  const getUsers = async () => {
    const fullListOfUsers = await GetFullListOfUsers();
    setUsers(fullListOfUsers);
    setFilteredUsers(fullListOfUsers);

    const admins = fullListOfUsers.filter(
      (user: User) => user.role === "admin"
    );
    const subscribed = fullListOfUsers.filter(
      (user: User) => user.subscriptionStatus
    );
    const notSubscribed = fullListOfUsers.filter(
      (user: User) => !user.subscriptionStatus
    );

    setAdmins(admins);
    setSubscribed(subscribed);
    setNotSubscribed(notSubscribed);
    setLoading(false);
  };

  useEffect(() => {
    getUsers();
  }, []);

  const handleSearch = (query: string) => {
    setSearchQuery(query);
    const filtered = users.filter(
      (user) =>
        user.email.toLowerCase().includes(query.toLowerCase()) ||
        user.role.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredUsers(filtered);
  };

  const changeUserRole = async (userId: string, newRole: string) => {
    try {
      setLoading(true);
      const response = await updateUserRole(userId, newRole);

      if (response.success) {
        toast.success("User role updated successfully", {
          description: `User role has been changed to ${newRole}`,
        });
        // Refresh the users list
        await getUsers();
      } else {
        toast.error("Failed to update user role", {
          description:
            response.message ||
            "An error occurred while updating the user role",
        });
      }
    } catch (error) {
      toast.error("Error updating user role", {
        description: "An unexpected error occurred",
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    users,
    filteredUsers,
    searchQuery,
    subscribed,
    notSubscribed,
    admins,
    loading,
    handleSearch,
    refreshUsers: getUsers,
    changeUserRole,
  };
}
